import { round } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateDimension } from '../../features/components/componentSlice'
import { chooseMaxPixels, convertToPerc, convertToPixels, isValidInput, uniqueComponentKey } from '../utility'

export const snapDimension = (dimension, value, position) => {
  switch (dimension) {
    case 'x':
      return Math.max(0, Math.min(100 - position.width, value))
    case 'y':
      return Math.max(0, Math.min(100 - position.height, value))
    case 'width':
      return Math.max(0, Math.min(100 - position.x, value))
    case 'height':
      return Math.max(0, Math.min(100 - position.y, value))
  }
}

const useTransformFieldProperties = ({ id, page, position, dimension }) => {
  const dispatch = useDispatch()
  const key = uniqueComponentKey(...id)
  const currentPageWidth = useSelector(({ pages }) => pages.pageWidth)
  const { width: pageWidth, height: pageHeight } = useSelector(
    ({ pages }) => pages.all[page].page_sizes[currentPageWidth]
  )

  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    const valueConverted = convertToPixels(position[dimension], chooseMaxPixels(dimension, pageWidth, pageHeight))
    setInputValue(round(valueConverted, 2) || 0)
  }, [position, dimension])

  const handleOnBlur = useCallback(() => {
    if (!isValidInput(inputValue)) return
    const valueConverted = convertToPerc(inputValue, chooseMaxPixels(dimension, pageWidth, pageHeight))
    const deltaPosition = { ...position, [dimension]: valueConverted }
    const value = snapDimension(dimension, valueConverted, deltaPosition)
    dispatch(updateDimension({ key, value, dimension }))
  }, [inputValue, position, dimension])

  const handleOnKeyDown = useCallback((e) => {
    if (e.key === 'Enter') e.target.blur()
  }, [])

  return useCallback(
    () => ({
      type: 'number',
      value: inputValue,
      onChange: (e) => setInputValue(e.target.value),
      onBlur: (e) => handleOnBlur(e),
      onKeyDown: (e) => handleOnKeyDown(e),
    }),
    [inputValue, handleOnBlur, handleOnKeyDown]
  )
}

export default useTransformFieldProperties
